import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { CouponCodeItemStatus } from "clearline-api";
import { CouponCodeDisplay } from "../validate-coupon.model";

@Component({
  selector: "app-coupon-card",
  templateUrl: "./coupon-card.component.html",
  styleUrls: ["./coupon-card.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CouponCardComponent {
  @Input() coupon: CouponCodeDisplay;
  @Input() isActive = false;
  @Input() isRedeemed = false;

  CouponCodeItemStatus = CouponCodeItemStatus;
}
